import { render, staticRenderFns } from "./SipupSlider.vue?vue&type=template&id=50d63def"
import script from "./SipupSlider.vue?vue&type=script&lang=js"
export * from "./SipupSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports